<template>
    <b-modal id="notification-data-modal" size="md" centered hide-header hide-footer body-class="p-0">
        <DevicesNotification ref="devices-notification-ref" @save-devices="handleDeviceSave"></DevicesNotification>
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="device-modal d-flex flex-row align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
                    <path
                        fill="#ffffff"
                        d="M11 13h2V8h-2zm1 3q.425 0 .713-.288T13 15t-.288-.712T12 14t-.712.288T11 15t.288.713T12 16m-8 3v-2h2v-7q0-2.075 1.25-3.687T10.5 4.2v-.7q0-.625.438-1.062T12 2t1.063.438T13.5 3.5v.7q2 .5 3.25 2.113T18 10v7h2v2zm8 3q-.825 0-1.412-.587T10 20h4q0 .825-.587 1.413T12 22m-4-5h8v-7q0-1.65-1.175-2.825T12 6T9.175 7.175T8 10z"
                    />
                </svg>
                <p class="text-light m-0 fs-4 ms-1">{{ title }}</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg" />
            </div>
        </div>
        <div class="d-flex flex-column p-3">
            <b-form-group label="Nombre:" label-for="name">
                <b-form-input
                    id="name"
                    v-model="name"
                    class="mb-2"
                    placeholder="Ejm: Alertas Camiones"
                    trim
                ></b-form-input>
            </b-form-group>
            <b-form-group label="Tipo de Notificación:" label-for="select_type">
                <b-form-select
                    id="select_type"
                    v-model="selected"
                    :options="options"
                    size="sm"
                    class="form-select mb-2"
                ></b-form-select>
            </b-form-group>
            <b-form-group label="Correos:" label-for="emails">
                <ul class="list-group mb-2">
                    <li
                        class="list-group-item item-email d-flex flex-row"
                        v-for="(email, index) in emailItems"
                        :key="index"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-mail"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            stroke-width="0.5"
                            stroke="#2c3e50"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" />
                            <path d="M3 7l9 6l9 -6" />
                        </svg>
                        <input type="text" v-model="emailItems[index]" class="email-input w-100 px-2 border rounded" />
                        <svg
                            @click="deleteEmailItem(index)"
                            xmlns="http://www.w3.org/2000/svg"
                            class="delete icon icon-tabler icon-tabler-trash"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="#2c3e50"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M4 7l16 0" />
                            <path d="M10 11l0 6" />
                            <path d="M14 11l0 6" />
                            <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                            <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                        </svg>
                    </li>
                </ul>
            </b-form-group>
            <span class="badge d-flex text-bg-primary mb-2" @click="addEmailSlot">Agregar Correo</span>
            <button type="button" class="btn btn-outline-primary my-2" @click="openDevices">
                Agregar Unidades ({{ assignedDevices }})
            </button>
            <b-button variant="primary" @click="save">Guardar</b-button>
        </div>
    </b-modal>
</template>

<script lang="ts">
import NotificationService from '@/api/services/notification.service'
import globalModule from '@/store/modules/global.module'
import notificationsModule from '@/store/modules/notifications.module'
import { Component, Vue, Watch } from 'vue-property-decorator'
import DevicesNotification from './DevicesNotification.vue'

@Component({ components: { DevicesNotification } })
export default class NotificationData extends Vue {
    name = ''
    selected = 'alarm'
    options = notificationsModule.notificationsOptions
    devicesId: number[] = []
    emailItems = ['', '']
    notificationId = 0

    get mode() {
        return notificationsModule.notificationModalMode
    }

    get title() {
        return this.mode === 'create' ? 'Crear Notificación' : 'Editar Notificación'
    }

    get modalData(){
        return notificationsModule.notificationDataModal
    }

    get assignedDevices(){
        return this.devicesId.length || 0
    }

    @Watch("modalData", { immediate: true })
    onChangeData(notificationData:any): void {
        this.name = notificationData.name || ''
        this.notificationId = notificationData.id || 0
        this.selected = notificationData.selected|| 'alarm'
        this.devicesId = notificationData.devicesId || []
        this.emailItems = notificationData.emailItems || ['', '']
    }

    close() {
        this.$bvModal.hide('notification-data-modal')
    }

    show() {
        this.$bvModal.show('notification-data')
    }

    async save() {
        if (this.mode === 'create') {
            const res = await NotificationService.createNotification({
                attributes: {
                    name: this.name,
                    emails: this.emailItems.filter((email) => email !== '' && email.includes('@')),
                    enable: true,
                    userId: globalModule.user.id,
                },
                type: this.selected,
                id: this.notificationId
            }, this.devicesId)
            notificationsModule.addNotifications(res.data)
            this.close()
        }else if(this.mode === 'edit'){
            const res = await NotificationService.editNotification({
                attributes: {
                    name: this.name,
                    emails: this.emailItems.filter((email) => email !== '' && email.includes('@')),
                    enable: true,
                    userId: globalModule.user.id,
                },
                type: this.selected,
                id: this.notificationId
            }, this.devicesId)
            notificationsModule.replaceNotification(res.data)
            this.close()
        }
    }

    openDevices() {
        const modal: any = this.$refs['devices-notification-ref']
        modal.onChangeNotificationsDevices(this.devicesId)
        this.$bvModal.show('notification-devices-modal')
    }

    addEmailSlot() {
        this.emailItems.push('')
    }

    deleteEmailItem(index: number) {
        this.emailItems.splice(index, 1)
    }

    handleDeviceSave(selectedDeviceIds: number[]) {
        this.devicesId = selectedDeviceIds
    }
}
</script>

<style lang="sass" scoped>
@import '@/assets/style/variables.sass'
@import '@/assets/style/modal-styles.sass'

div
    font-family: 'Changa', sans-serif !important
.form-check-label
    gap: 5px
    cursor: pointer
.list-group
    overflow: auto !important
    max-height: 30vh !important
.list-group-item
    p
        line-height: 20px
    img
        height: 30px

select
    cursor: pointer

.badge
    align-self: end

.item-email
    gap: 5px
    svg
        stroke: $secondary !important
        stroke-width: 2px
        width: auto
        height: 30px
.badge, .delete
    cursor: pointer
    transition: all .1s ease
    &:active
        transform: scale(.9)
</style>
